const QUANTITY_LABELS = {
  Forex: 'Lot Size',
  Stocks: 'Shares',
  ETFs: 'Shares',
  Cryptocurrencies: 'Units',
  Indices: 'Contracts',
  Metals: 'Contracts',
  Energy: 'Contracts',
  Commodities: 'Contracts',
  Futures: 'Contracts',
};

export function getQuantityLabel(category) {
  return QUANTITY_LABELS[category] || 'Quantity';
}

export function isBuyDirection(direction) {
  const d = direction?.toUpperCase();
  return d === 'BUY' || d === 'LONG';
}

export function getDirectionColor(direction) {
  return isBuyDirection(direction)
    ? 'text-green-500'
    : 'text-red-500';
}

export function getAssetParams(symbol, assets) {
  if (!symbol || !assets?.length) return null;
  const asset = assets.find(a => a.symbol === symbol);
  if (!asset || !asset.pip_size || !asset.contract_size) return null;
  return {
    pipSize: parseFloat(asset.pip_size),
    contractSize: parseFloat(asset.contract_size),
    category: asset.category,
  };
}

export function calculatePips({ entryPrice, exitPrice, direction, pipSize }) {
  const entry = parseFloat(entryPrice);
  const exit = parseFloat(exitPrice);
  if (isNaN(entry) || isNaN(exit) || !pipSize || !direction) return null;

  const diff = isBuyDirection(direction)
    ? (exit - entry) / pipSize
    : (entry - exit) / pipSize;

  return Math.round(diff * 100) / 100;
}

export function calculateProfit({ entryPrice, exitPrice, direction, quantity, contractSize }) {
  const entry = parseFloat(entryPrice);
  const exit = parseFloat(exitPrice);
  const qty = parseFloat(quantity);
  if (isNaN(entry) || isNaN(exit) || isNaN(qty) || !contractSize || !direction) return null;

  const diff = isBuyDirection(direction)
    ? (exit - entry) * qty * contractSize
    : (entry - exit) * qty * contractSize;

  return Math.round(diff * 100) / 100;
}
